import { getDurationFrom } from './timeHelper'

export const GPS_TRACKER_LOCATION_STALE_WARNING_MINUTES = 180
export const GPS_TRACKER_RECENT_COMMUNICATION_MINUTES = 120
export const GPS_TRACKER_LOCATION_STALE_WARNING_MESSAGE = '定期通信はできていますが、GPS位置情報は更新されていません。\n設置場所やGPSの受信状況により、位置情報の更新に時間がかかることがあります。'

const getTimestampTime = (dateTime?: string | null): number | null => {
  if (!dateTime) return null

  const time = new Date(dateTime).getTime()

  return Number.isFinite(time) ? time : null
}

const getLatestTimestamp = (dateTimes: (string | null | undefined)[]): string | null => {
  const latest = dateTimes.reduce<{ timestamp: string | null, time: number }>((current, dateTime) => {
    const time = getTimestampTime(dateTime)

    if (time === null || time <= current.time) {
      return current
    }

    return {
      timestamp: dateTime || null,
      time,
    }
  }, {
    timestamp: null,
    time: Number.NEGATIVE_INFINITY,
  })

  return latest.timestamp
}

const getElapsedMinutes = (dateTime?: string | null): number | null => {
  if (!dateTime) return null

  const minutes = getDurationFrom(dateTime).asMinutes()

  return Number.isFinite(minutes) && minutes >= 0 ? minutes : null
}

export const shouldShowGpsTrackerLocationStaleWarning = (
  status?: Pick<IGpsTrackerStatus, 'heartbeat_received_at' | 'tracked_at' | 'gps_location_updated_at'> | null,
): boolean => {
  const communicationAt = getLatestTimestamp([
    status?.heartbeat_received_at,
    status?.tracked_at,
  ])
  const communicationElapsedMinutes = getElapsedMinutes(communicationAt)
  const gpsLocationElapsedMinutes = getElapsedMinutes(status?.gps_location_updated_at)

  if (communicationElapsedMinutes === null || gpsLocationElapsedMinutes === null) {
    return false
  }

  return communicationElapsedMinutes <= GPS_TRACKER_RECENT_COMMUNICATION_MINUTES
    && gpsLocationElapsedMinutes >= GPS_TRACKER_LOCATION_STALE_WARNING_MINUTES
}
